(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["21scent-collection-circle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__cclLoaded) return;
  window.__cclLoaded = true;

  function state(root) {
    var list = root.querySelector('[data-ccl-list]');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    var rtl = getComputedStyle(list).direction === 'rtl';
    var left = rtl ? max + list.scrollLeft : list.scrollLeft;
    var prev = root.querySelector('[data-ccl-prev]');
    var next = root.querySelector('[data-ccl-next]');
    if (prev) prev.disabled = left <= 1;
    if (next) next.disabled = left >= max - 1;
    var fits = max <= 1 ? 'true' : 'false';
    if (root.getAttribute('data-fits') !== fits) root.setAttribute('data-fits', fits);
  }

  function bind(root) {
    if (root.__ccl || root.getAttribute('data-arrows') !== 'true') return;
    root.__ccl = true;
    var list = root.querySelector('[data-ccl-list]');
    if (!list) return;
    var t;
    list.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { state(root); }, 60);
    }, { passive: true });
    if ('ResizeObserver' in window) {
      var raf;
      new ResizeObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { state(root); }); }).observe(list);
    }
    window.addEventListener('resize', function () { state(root); }, { passive: true });
    state(root);
  }

  function boot() { document.querySelectorAll('[data-ccl]').forEach(bind); }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ccl-prev],[data-ccl-next]') : null;
    if (!b) return;
    var root = b.closest('[data-ccl]');
    var list = root && root.querySelector('[data-ccl-list]');
    if (!list) return;
    var dir = b.hasAttribute('data-ccl-next') ? 1 : -1;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollBy({ left: dir * Math.max(120, list.clientWidth * 0.8), behavior: reduced ? 'auto' : 'smooth' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ccl]');
    if (el) bind(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-minimal"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__cpcLoaded) return;
  window.__cpcLoaded = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sliders = [];

  function handleATC(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var labelEl = btn.querySelector('[data-atc-label]');
    var origLabel = labelEl ? labelEl.textContent : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function reset(ms) {
      setTimeout(function () {
        btn.removeAttribute('data-state');
        if (labelEl) labelEl.textContent = origLabel;
      }, ms);
    }
    btn.setAttribute('data-state', 'loading');
    if (labelEl) labelEl.textContent = '...';

    var sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: sections })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (data) {
        btn.setAttribute('data-state', 'added');
        if (labelEl) labelEl.textContent = '✓';
        var secs = data.sections || {};
        var cn = document.querySelector('cart-notification');
        if (cn && typeof cn.renderContents === 'function') cn.renderContents({ key: data.key, sections: secs });
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          if (typeof cd.renderContents === 'function') cd.renderContents({ key: data.key, sections: secs });
          if (typeof cd.open === 'function') cd.open(btn);
        }
        if (typeof publish === 'function') publish('cart-update', { source: 'product-form', productVariantId: parseInt(variantId, 10) });
        var iconHtml = secs['cart-icon-bubble'];
        if (iconHtml) {
          var doc = new DOMParser().parseFromString(iconHtml, 'text/html');
          var fresh = doc.querySelector('.shopify-section');
          document.querySelectorAll('#cart-icon-bubble').forEach(function (el) { if (fresh) el.innerHTML = fresh.innerHTML; });
        } else {
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var n = cart.item_count;
            ['[data-cart-count]', '.cart-count', '#cart-count', '.cart__count', '.cart-count-bubble span:not(.visually-hidden)']
              .forEach(function (sel) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = n; }); });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          }).catch(function () {});
        }
        reset(2000);
      })
      .catch(function () {
        btn.setAttribute('data-state', 'error');
        if (labelEl) labelEl.textContent = '✗';
        reset(2400);
      });
  }

  function Slider(root) {
    var rail = root.querySelector('[data-cpc-rail]');
    if (!rail) return;
    var x = 0, vel = 0, dragging = false, startX = 0, startY = 0, startPos = 0, lastX = 0, lastT = 0, dir = null;

    function items() { return rail.querySelectorAll('.cpc__item'); }
    function gap() { return parseInt(getComputedStyle(rail).columnGap, 10) || 0; }
    function stops() {
      var list = items(), g = gap(), off = 0, out = [];
      for (var i = 0; i < list.length; i++) { out.push(-off); off += list[i].offsetWidth + g; }
      out.push(-maxX());
      return out;
    }
    function maxX() {
      var list = items(), g = gap(), w = 0;
      for (var i = 0; i < list.length; i++) w += list[i].offsetWidth + (i < list.length - 1 ? g : 0);
      return Math.max(0, w - root.offsetWidth);
    }
    function clamp(v) { return Math.max(-maxX(), Math.min(0, v)); }
    function setX(v, animate) {
      x = clamp(v);
      rail.style.transition = animate && !reduced ? 'transform .45s cubic-bezier(.25,.46,.45,.94)' : 'none';
      rail.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function snap(momentum) {
      var s = stops(), p = x + momentum * 80, best = s[0], bd = Infinity;
      s.forEach(function (v) { var d = Math.abs(p - v); if (d < bd) { bd = d; best = v; } });
      setX(best, true);
    }
    function go(d) {
      var s = stops(), cur = 0, bd = Infinity;
      s.forEach(function (v, i) { var dd = Math.abs(x - v); if (dd < bd) { bd = dd; cur = i; } });
      setX(s[Math.max(0, Math.min(s.length - 1, cur + d))], true);
    }

    rail.addEventListener('touchstart', function (e) {
      rail.style.transition = 'none';
      var t = e.touches[0];
      startX = lastX = t.clientX; startY = t.clientY; startPos = x; lastT = Date.now(); vel = 0; dir = null; dragging = false;
    }, { passive: true });

    rail.addEventListener('touchmove', function (e) {
      var t = e.touches[0], dx = t.clientX - startX, dy = t.clientY - startY, now = Date.now();
      if (!dir) {
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
        return;
      }
      if (dir === 'v') return;
      e.preventDefault();
      dragging = true;
      var dt = now - lastT;
      if (dt > 0) vel = (t.clientX - lastX) / dt;
      lastX = t.clientX; lastT = now;
      var nx = startPos + dx, max = maxX();
      if (nx > 0) nx = nx * 0.22;
      if (nx < -max) nx = -max + (nx + max) * 0.22;
      x = nx;
      rail.style.transform = 'translate3d(' + x + 'px,0,0)';
    }, { passive: false });

    rail.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false; dir = null;
      snap(vel); vel = 0;
    }, { passive: true });

    rail.addEventListener('touchcancel', function () { dragging = false; dir = null; snap(0); }, { passive: true });

    root.__cpcGo = go;
    root.__cpcResize = function () { setX(x, false); };
    sliders.push(root);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      reveal(en.target);
    });
  }, { rootMargin: '0px 0px -60px 0px' }) : null;

  function reveal(root) {
    root.classList.add('is-visible');
    if (root.getAttribute('data-slider') === 'true' && !root.__cpcGo) Slider(root);
  }

  function init(root) {
    if (!root || root.__cpc) return;
    root.__cpc = true;
    if (!io || reduced || root.getAttribute('data-anim') !== 'true') reveal(root);
    else io.observe(root);
  }

  function boot() { document.querySelectorAll('[data-cpc]').forEach(init); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-cpc-atc]');
    if (btn) {
      e.preventDefault();
      if (btn.getAttribute('data-state') !== 'loading') handleATC(btn);
      return;
    }
    var arrow = t.closest('[data-cpc-prev],[data-cpc-next]');
    if (arrow) {
      var root = arrow.closest('[data-cpc]');
      if (root && !root.__cpcGo) reveal(root);
      if (root && root.__cpcGo) root.__cpcGo(arrow.hasAttribute('data-cpc-next') ? 1 : -1);
    }
  });

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      sliders = sliders.filter(function (r) { return r.isConnected; });
      sliders.forEach(function (r) { r.__cpcResize(); });
    }, 120);
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cpc]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
